import { ArrowOut16, ArticleHeading0, ArticleHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface IAuthorFactProps {
  value: number;
  text: string;
  testId: string;
  link?: string | null;
  onClick?(): void;
}

export const AuthorFact = (props: IAuthorFactProps) => {
  const { testId, text, value, link, onClick } = props;

  const [hovered, setHovered] = React.useState(false);
  const changeHovered = React.useCallback(() => setHovered(!hovered), [hovered]);
  const color = hovered ? 'primary_100' : 'black_100';

  const content = (text: string, hasArrow: boolean) => (
    <div className={styles['container']}>
      <ArticleHeading0 color={color}>{value}</ArticleHeading0>

      <div className={styles['text']}>
        <ArticleHeading5 as="h5" color={color}>
          <span
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: text }}
          ></span>

          {hasArrow && (
            <div className={styles['arrow']}>
              <ArrowOut16 color="primary_100" />
            </div>
          )}
        </ArticleHeading5>
      </div>
    </div>
  );

  return (
    <>
      {link && (
        <a
          data-testid={testId}
          className={styles['link']}
          href={link}
          target="blank"
          rel="noreferrer"
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}
          onMouseOver={changeHovered}
          onMouseOut={changeHovered}
        >
          {content(text, true)}
        </a>
      )}

      {!link && <div data-testid={testId}>{content(text, false)}</div>}
    </>
  );
};
